import { TABS_ID } from './tabs';
export const routes = {
  base: '/google-meet-add-on-ui',
  outsideMeeting: '/outside-active-meeting',
  draft: '/draft',
  accounts: '/accounts',
  reconnect: '/reconnect',
  home: '/',
  portalId: '/:portalId',
  contacts: `/${TABS_ID.contacts}`,
  associations: `/${TABS_ID.associations}`,
  comments: `/${TABS_ID.comments}`,
  playbooks: `/${TABS_ID.playbooks}`
};
export const unauthorizedRoutesParam = 'autoRedirect';
export const repeatedVisitKey = 'isRepeatedVisit';
export const acceptanceTestBaseRoute = 'google-meet-add-on-ui-test';